module.exports = __webpack_public_path__ + "img/borderShieldWhite.e2adfe46.svg";